import Icon from '@loggi/ui/components/icon';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import React from 'react';
import styles from './confirmed-delivery-message.styles.scss';
import CONFIRMED_DELIVERY_MESSAGE from './confirmed-delivery-message.constants';

export default function ConfirmedDeliveryMessage() {
  return (
    <View className={styles.confirmedDeliveryContainer}>
      <Icon type={icons.type.CONFIRMATION} color={colors.type.GREEN_500} />
      <Text color={colors.type.GREEN_700} size="200">
        {CONFIRMED_DELIVERY_MESSAGE}
      </Text>
    </View>
  );
}
